import classnames from 'classnames';
import { ArrowLeftOutlined } from '@JohnLewisPartnership/jl-design-system/dist/components/icons/ArrowLeftOutlined'
import Link from 'jl-design-system/elements/link/Link';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { FeaturesContext } from '~/components/features/with-features.hoc';
import Icon from '../icon/Icon';
import styles from './breadcrumb.scss';

// import { isExternalUrl, stripLocal } from '../utils/route/url';

const Breadcrumb = ({ text, className, ...allOtherProps }) => {
  // TODO these lines were from my account implementation. Currently we no need extra logic to evaluate prop: 'external' and 'to'
  // const isExternal = isExternalUrl(to);
  // const url = stripLocal(to);
  const { isBPLayoutActive } = useContext(FeaturesContext);
  if (!text) {
    return null;
  }

  return (
    text && (
      <Link className={classnames([styles.backItem, className])} {...allOtherProps}>
        {isBPLayoutActive ? (
           <ArrowLeftOutlined  size="medium" />
        ) : (
          <Icon className={styles.backIcon} name="chevron-left" />
        )}
        <span className={styles.backText}>{text}</span>
      </Link>
    )
  );
};

Breadcrumb.propTypes = {
  className: PropTypes.string,
  to: PropTypes.string,
  text: PropTypes.string,
  external: PropTypes.bool,
};
Breadcrumb.defaultProps = {
  className: '',
  to: `${process.env.REACT_APP_BROWSE_HOST}/our-services`,
  text: 'navBack',
  external: true,
};

export default Breadcrumb;
